var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketingDropdownArrowIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.98,
    height: 7.075,
    viewBox: "0 0 10.98 7.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "caret-up",
    d: "M102.962,151.769l-4.684,5.466a.8.8,0,0,1-1.221,0l-4.684-5.466a.8.8,0,0,1,.611-1.328h9.369A.8.8,0,0,1,102.962,151.769Z",
    transform: "translate(-92.178 -150.442)",
    fill: "#d2d2d2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketingDropdownArrowIcon);
export default __webpack_public_path__ + "static/media/ticketing-dropdown-arrow-icon.bb6c984281da8ab8e20bb46dc22f18ad.svg";
export { ForwardRef as ReactComponent };